import { useState } from "react";
import WizardProgressBar from "./components/WizardProgressBar";
import "./wizard.css";
import ListBusinessSignUp from "./publicWizardSteps/ListBusinessSignUp";
import ListBusinessContactForm from "./publicWizardSteps/ListBusinessContactForm";
import ListBusinessProfile from "./publicWizardSteps/ListBusinessProfile";
import ListBusinessMyPage from "./publicWizardSteps/ListBusinessMyPage";
import ListBusinessPaymentPage from "./publicWizardSteps/ListBusinessPaymentPage";
import { Helmet } from "react-helmet-async";

const BusinessListingPublicWizard = ({ step = 1, subscriptionId }) => {
    const [currentStep, setCurrentStep] = useState(step);
    const [formData, setFormData] = useState({
        subscriptionId: subscriptionId || "",
        emailId: "",
        password: "",
        personName: "",
        designationID: "",
        companyTypeID: "",
        mobileNo: "",
        telephoneNo: "",
        address: "",
        emirate: "",
        companyName: "",
        webAddress: "",
        location: "",
        country: "65f95f070d6753c3bdacccd9",
        userLink: "",
        userName: "",
    });

    const steps = [
        { id: 1, title: "Account" },
        { id: 2, title: "Basic Info" },
        { id: 3, title: "Create Profile" },
        { id: 4, title: "Business Page" },
        { id: 5, title: "Payment" },
    ];

    const handleNext = () => setCurrentStep((prev) => Math.min(prev + 1, steps.length));
    const handleBack = () => setCurrentStep((prev) => Math.max(prev - 1, 1));

    const updateData = (keyOrObject, value) => {
        setFormData((prev) => {
            if (typeof keyOrObject === "object") {
                return { ...prev, ...keyOrObject };
            }
            return { ...prev, [keyOrObject]: value };
        });
    };

    return (
        <>
            <Helmet>
                <title>NeooSearch – List your business </title>
                <meta name="description" content="List your business start connecting with your customers and building your business network." data-rh="true" />
                <meta property="og:image" content="https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png" data-rh="true" />
            </Helmet>
            <div className="pub-wizrd-item-section cust_container">
                <WizardProgressBar steps={steps} currentStep={currentStep} />
                <div className="mt-2 ml-2 mr-2">
                    {currentStep === 1 && (<ListBusinessSignUp formData={formData} updateData={updateData} onNext={handleNext} />)}
                    {currentStep === 2 && (<ListBusinessContactForm formData={formData} updateData={updateData} onNext={handleNext} onBack={handleBack} />)}
                    {currentStep === 3 && (<ListBusinessProfile formData={formData} updateData={updateData} onNext={handleNext} onBack={handleBack} />)}
                    {currentStep === 4 && (<ListBusinessMyPage formData={formData} updateData={updateData} onNext={handleNext} onBack={handleBack} />)}
                    {currentStep === 5 && (<ListBusinessPaymentPage formData={formData} onBack={handleBack} />)}
                </div>
            </div>
        </>
    );
};
export default BusinessListingPublicWizard;
